import React from "react";
import { MyLeaveBar } from "my-leave/components";
import { useMyLeaveSummaryChartData } from "my-leave/hooks";

interface MyLeaveCovidPlusTenCardProps {
  selectedYear: number;
  contract: any; // Replace 'any' with the actual contract type if known
}

export const MyLeaveCovidPlusTenCard: React.FC<
  MyLeaveCovidPlusTenCardProps
> = ({ selectedYear, contract }) => {
  const { data } = useMyLeaveSummaryChartData({
    year: String(selectedYear),
    contract,
  });

  if (!data?.allCovidPlus10LeaveDays || data?.allCovidPlus10LeaveDays === 0) {
    return null;
  }

  return (
    <MyLeaveBar
      id="covid-leave-days-bar"
      label={"MY_LEAVE_COVID_PLUS_10"}
      all={data?.allCovidPlus10LeaveDays}
      available={data?.availableCovidPlus10LeaveDays}
      requested={data?.requestedCovidPlus10LeaveDays}
      fulfilled={data?.fulfilledCovidPlus10Days}
    />
  );
};
export default MyLeaveCovidPlusTenCard;
